import { Box, CircularProgress, Typography } from "@mui/material";
import { EPath } from "constants/path";
import { AuthProvider } from "contexts/AuthContext";
import { SidebarProvider } from "contexts/SidebarContext";
import { ToastProvider } from "contexts/ToastContext";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router";
import NotFound from "routes/NotFound";
import ProtectedRoute from "routes/ProtectedRoute";
import routeConfig, { RouteConfig } from "routes/routeConfig";
import { CelleraThemeProvider } from "theme/CelleraThemeProvider";

import {
  LazyAppRedirectPage,
  LazyAuthActionPage,
  LazyForgotPasswordPage,
  LazyLegalDocumentPage,
  LazyLoginPage,
  LazyResetPasswordPage,
  LazyRxntClosePage,
  LazySignUpPage,
} from "./routes/lazyPages";

const PageLoadingFallback: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      gap: 2,
      backgroundColor: "#f5f5f5",
    }}
  >
    <CircularProgress size={40} />
    <Typography variant="body1" color="text.secondary">
      Loading...
    </Typography>
  </Box>
);

const generateRoutes = (routes: RouteConfig[]) => {
  return routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={<ProtectedRoute route={route} />}
    />
  ));
};

function App() {
  return (
    <CelleraThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <SidebarProvider>
            <Suspense fallback={<PageLoadingFallback />}>
              <Routes>
                {generateRoutes(routeConfig)}
                <Route path={EPath.LOGIN} element={<LazyLoginPage />} />
                <Route
                  path={EPath.FORGOT_PASSWORD}
                  element={<LazyForgotPasswordPage />}
                />
                <Route
                  path={EPath.RESET_PASSWORD}
                  element={<LazyResetPasswordPage />}
                />
                <Route path={EPath.SIGN_UP} element={<LazySignUpPage />} />
                <Route
                  path={EPath.AUTH_ACTION}
                  element={<LazyAuthActionPage />}
                />
                <Route
                  path={EPath.APP_REDIRECT}
                  element={<LazyAppRedirectPage />}
                />
                <Route
                  path={EPath.RXNT_CLOSE}
                  element={<LazyRxntClosePage />}
                />
                <Route
                  path={EPath.LEGAL_DOCUMENT}
                  element={<LazyLegalDocumentPage />}
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </SidebarProvider>
        </AuthProvider>
      </ToastProvider>
    </CelleraThemeProvider>
  );
}

export default App;
